export default "__VITE_ASSET__CPa0ZwxC__"